/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Alarms_Dialog_Delete_DescriptionInputs */



/**
* | output |
* | --- |
* | "Delete alarm point {name}?" |
*
* @param {Alarms_Dialog_Delete_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_dialog_delete_description = /** @type {((inputs: Alarms_Dialog_Delete_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Dialog_Delete_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Delete alarm point
 ${i?.name}?`)
	return /** @type {LocalizedString} */ (`Supprimer le point d'alarme
 ${i?.name} ?`)
});